import Slider from '../components/slider';

export default class PackageCardCredits {
  constructor() {
    this.cards = [];
    this.selectedIndexes = {};
    this.isSyncingSliders = false;

    document.querySelectorAll('.js-product-card-credits').forEach((el) => {
      const card = this.initCard(el);

      if (card) {
        this.cards.push(card);
      }
    });

    this.cards.forEach((card) => this.updateCard(card));
  }

  initCard(credits) {
    const el = credits.closest('.js-product-card');
    const container = credits.querySelector('.js-range-slider');

    if (!el || !container) {
      return null;
    }

    let creditSteps = [];

    try {
      creditSteps = JSON.parse(credits.dataset.creditSteps || '[]');
    } catch {
      creditSteps = [];
    }

    if (creditSteps.length === 0) {
      return null;
    }

    let slider;

    try {
      slider = new Slider(container);
    } catch (error) {
      console.error('Package card credits: slider could not be created', error);

      return null;
    }

    const sliderApi = container.querySelector('.js-range-slider__slider').noUiSlider;

    if (!sliderApi) {
      return null;
    }

    const uuid = credits.dataset.uuid || '';
    const product = credits.dataset.product || '';

    const card = {
      el,
      creditSteps,
      uuid,
      product,
      group: `${product}:${uuid}`,
      priceSoon: credits.dataset.priceSoon || '',
      slider: sliderApi,
    };

    this.selectedIndexes[card.group] = this.selectedIndexes[card.group] || 0;

    // `update` also covers track taps and keyboard, unlike `slide`/`change`.
    card.slider.on('update', (values, handle, unencoded) => {
      slider.updateUnitLabelText(unencoded[0]);
      this.selectCredits(card.group, unencoded[0]);
    });

    return card;
  }

  selectedIndex(card) {
    return this.selectedIndexes[card.group] || 0;
  }

  selectedStep(card) {
    return card.creditSteps[this.selectedIndex(card)] || {};
  }

  selectCredits(group, index) {
    // Ignore the `update` events our own sync triggers.
    if (this.isSyncingSliders) {
      return;
    }

    this.selectedIndexes[group] = Math.round(Number(index)) || 0;

    this.syncSliders(group);
    this.cards.filter((card) => card.group === group).forEach((card) => this.updateCard(card));
  }

  syncSliders(group) {
    this.isSyncingSliders = true;

    this.cards
      .filter((card) => card.group === group)
      .forEach((card) => card.slider && card.slider.set(this.selectedIndexes[group]));

    this.isSyncingSliders = false;
  }

  updateCard(card) {
    const step = this.selectedStep(card);

    card.el.dispatchEvent(
      new CustomEvent('update-prices', {
        detail: {
          price: step.price || '',
          priceVat: step.priceVat || step.price || '',
          priceProlong: step.priceProlong || '',
          priceProlongVat: step.priceProlongVat || step.priceProlong || '',
          isInitialPrice: this.selectedIndex(card) === 0,
        },
      }),
    );

    const note = card.el.querySelector('.product-card__price > span');

    if (note && !step.price) {
      note.textContent = card.priceSoon;
    }

    card.el.querySelectorAll('.js-product-card-credits-label').forEach((el) => {
      el.textContent = step.label || '';
    });

    this.updateCartParams(card);
  }

  updateCartParams(card) {
    const button = card.el.querySelector('.js-button-add-to-cart');

    if (!button?.attributes['@click']) {
      return;
    }

    const expression = button.attributes['@click'].nodeValue;

    if (!/{.*}/.test(expression)) {
      return;
    }

    const next = expression.replace(/{.*}/, JSON.stringify(this.cartParams(card)));

    // Write only when the value actually changes. During init the same card can
    // be updated twice in one tick (slider sync from a sibling card + the
    // constructor loop). Two identical writes to the @click attribute make
    // Alpine's mutation observer attach two click listeners, which adds the
    // product to the cart twice on a single click.
    if (next !== expression) {
      button.attributes['@click'].nodeValue = next;
    }
  }

  cartParams(card) {
    return {
      uuid: card.uuid,
      addons: { credits: Number(this.selectedStep(card).value || 0) },
      product: card.product,
    };
  }
}
